export default __webpack_public_path__ + "static/media/HRmobile.a8b7a6e2.png";